import React from 'react'

import { Container, Item, TitleContainer } from './styles'
import { TitleBackground, Title } from '../../MenuOption'

import LeaderboardItem from '../Item' 

function LeaderboardPlatform (props){
  return (
    <Container>
      <TitleContainer>
        <TitleBackground selected={ true }/>
        <Title selected={ true }>{ props.platform }</Title>
      </TitleContainer>
      <Item>
        <LeaderboardItem type="Nitro" value={ props.nitro }/>
      </Item>
      <Item>
        <LeaderboardItem type="Championship" value={ props.championship }/>
      </Item>
    </Container>
  )
}

export default LeaderboardPlatform